import { useMutation } from 'react-query';
import request from '../helpers/request';
import { useDispatch } from 'react-redux';
import { recordsActions } from '../actions/records.actions';

const deleteCallLisRecord = async ({ recordId }) => {
  return await request.delete(
    `/Phone/delete_call_list_record?recordId=${recordId}`,
    null,
    'Не удалось отвязать звонок от заявки',
    'Error'
  );
};
const useDeleteCallLisRecord = () => {
  const dispatch = useDispatch();

  const mutation = useMutation(deleteCallLisRecord, {
    onSuccess: (data, { requestId }) => {
      if (data !== 'Error') {
        dispatch(recordsActions.fetchRecords(requestId));
      }
    },
  });

  return {
    isLoading: mutation.isLoading,
    deleteCallLisRecord: mutation.mutateAsync,
  };
};

export default useDeleteCallLisRecord;
